import CustomIcon from './custom-icon';

/**
 * A wrapped present seen from above. Pairs with lucide's `Gift` (seen from the
 * side) so two gift categories can sit next to each other and still be told
 * apart by shape alone.
 */
const GiftWrappedIcon = (props) => (
  <CustomIcon {...props}>
    <rect height="16" rx="2" width="16" x="4" y="4" />
    <path d="M12 4v16" />
    <path d="M4 12h16" />
    <path d="M12 12c-2 0-4.2-1.4-3.6-3 .6-1.6 2.9-.7 3.6 3Z" />
    <path d="M12 12c2 0 4.2-1.4 3.6-3-.6-1.6-2.9-.7-3.6 3Z" />
  </CustomIcon>
);

export default GiftWrappedIcon;
